import { render, staticRenderFns } from "./CustomerLevels.vue?vue&type=template&id=765c618b&"
import script from "./CustomerLevels.vue?vue&type=script&lang=js&"
export * from "./CustomerLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports